import { cn } from '../../lib/cn';
import { Card, Badge } from '../ui';

type Section = { title: string; priority: string; summary: string };

type Props = {
  greeting?: string;
  sections?: Section[];
  className?: string;
};

export function ExecutiveBriefingCard({
  greeting = "Good morning — here's your commerce briefing",
  sections = [],
  className,
}: Props) {
  const priorityVariant = (p: string) => {
    if (p === 'critical' || p === 'high') return 'error' as const;
    if (p === 'normal') return 'default' as const;
    return 'info' as const;
  };

  return (
    <Card className={cn('border-brand-200 bg-brand-50/20 dark:border-brand-900 dark:bg-brand-950/20', className)}>
      <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">Executive Briefing</p>
      <p className="mt-2 text-sm font-medium text-slate-900 dark:text-slate-100">{greeting}</p>
      <div className="mt-4 space-y-3">
        {sections.map((s) => (
          <div key={s.title} className="rounded-lg bg-white/60 p-3 dark:bg-slate-900/60">
            <div className="flex items-center gap-2">
              <p className="text-sm font-medium">{s.title}</p>
              <Badge variant={priorityVariant(s.priority)}>{s.priority}</Badge>
            </div>
            <p className="mt-1 text-xs text-slate-600 dark:text-slate-400">{s.summary}</p>
          </div>
        ))}
      </div>
    </Card>
  );
}
